import type { IconData } from '@stacksjs/iconify-core'

export const externalLink: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M400 464H48V104h192V72H16v424h416V272h-32z\"/><path fill=\"currentColor\" d=\"M304 16v32h137.373L188.687 300.687l22.626 22.626L464 70.627V208h32V16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default externalLink
